import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject, model, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

import { UserService } from "../../../apis/networkdashboard/rest/services";
import { SafeButton } from "../../common/safe-button/safe-button";

type DialogState = "idle" | "sending" | "success" | "failure";

@Component({
  selector: "dialog-user-interview",
  templateUrl: "dialog-user-interview.html",
  styleUrls: ["dialog-user-interview.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafeButton, FormsModule, TranslatePipe],
})
export class DialogUserInterviewComponent {
  private readonly user = inject(UserService);

  protected dialogRef = inject(MatDialogRef<DialogUserInterviewComponent>);
  protected message = model("");
  protected confirmed = model(false);
  protected state = signal<DialogState>("idle");

  protected idle = computed(() => this.state() === "idle");
  protected sending = computed(() => this.state() === "sending");
  protected success = computed(() => this.state() === "success");
  protected failure = computed(() => this.state() === "failure");

  protected cancel() {
    this.dialogRef.close(this.success());
  }

  protected async send() {
    this.state.set("sending");
    const registration = { body: { message: this.message() } };
    const result = await this.user.registerForUserInterview(registration).catch(() => new Error()); // Return error so we can check the status and display an error message
    this.state.set(result instanceof Error ? "failure" : "success");
  }

  protected reset() {
    this.state.set("idle");
  }
}
